import { render, staticRenderFns } from "./wechatUser.vue?vue&type=template&id=181fc3e8&scoped=true&"
import script from "./wechatUser.vue?vue&type=script&lang=js&"
export * from "./wechatUser.vue?vue&type=script&lang=js&"
import style0 from "./wechatUser.vue?vue&type=style&index=0&id=181fc3e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181fc3e8",
  null
  
)

component.options.__file = "wechatUser.vue"
export default component.exports